import React from 'react';
import styled from 'styled-components';
import theme from '../../pagesv2/theme';

const ToggleWrap = styled.div`
  display: inline-flex;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radii.sm};
  overflow: hidden;
  background: ${theme.colors.surface};
`;

const ToggleOption = styled.button`
  padding: 6px 14px;
  border: none;
  background: ${p => p.$active ? theme.colors.primary : 'transparent'};
  color: ${p => p.$active ? '#fff' : theme.colors.textSecondary};
  font-family: inherit;
  font-size: ${theme.typography.small.size};
  font-weight: 500;
  cursor: pointer;
  transition: background ${theme.transitions.fast}, color ${theme.transitions.fast};

  &:hover:not(:disabled) {
    background: ${p => p.$active ? theme.colors.primaryDark : theme.colors.surfaceHover};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const ScopeToggle = ({ scope, onChange, disabled }) => {
  return (
    <ToggleWrap>
      <ToggleOption
        $active={scope === 'self'}
        onClick={() => onChange('self')}
        disabled={disabled}
        type="button"
      >
        My meetings
      </ToggleOption>
      <ToggleOption
        $active={scope === 'team'}
        onClick={() => onChange('team')}
        disabled={disabled}
        type="button"
      >
        My team's meetings
      </ToggleOption>
    </ToggleWrap>
  );
};

export default ScopeToggle;
